"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTouchDevice = isTouchDevice;
function isTouchDevice() {
    // @ts-ignore
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
